<template>
  <span class="pill pill--purple-glow sonar-top-skill-pill">{{
    topSkill
  }}</span>
</template>

<script>
export default {
  name: 'SonarTopSkillPill',
  props: {
    topSkill: {
      type: String,
      required: true,
    },
  },
}
</script>

<style scoped>
.sonar-top-skill-pill {
  font-family: var(--font-book);
  width: auto;
  white-space: nowrap;
}
</style>
